module.exports = __webpack_public_path__ + "img/xx-icon-shuang.2203ad7e.svg";